import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';
import { BASE_URL } from '../constants';
import { environment } from '../../../environments/environment';
import { Token } from '@angular/compiler';
import { Router } from '@angular/router';
import { AuthResponse } from '../models/auth-response';
import { UserDetails } from '../models/user-details';

//interface TokenData {
//    accessToken: string;
//    refreshToken: string;
//}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public userDetails: UserDetails | null = null;
    private isAuthorized: boolean = false;
    accessToken: any;

    constructor(private dataService: DataService, private router: Router, @Inject(BASE_URL) private baseUrl: string)
    {
        this.loadUserDetailsFromSession();
    }

    getAccessToken(authCode: string): Promise<AuthResponse | undefined> {
        return this.dataService.get<AuthResponse>(`api/auth/access-token?authCode=${authCode}`).toPromise()
            .then(data => {
                this.setToken(data!);
                return data;
            })
            .catch(error => {
                console.error('Error fetching access token:', error);
                return undefined;
            });
    }

    getRefreshToken(refreshToken: string | null): Promise<AuthResponse | undefined> {
        return this.dataService.get<AuthResponse>(`api/auth/refresh-token?refreshToken=${refreshToken}`).toPromise()
            .then(data => {
                this.setToken(data!);
                return data;
            })
            .catch(error => {
                console.error('Error fetching refresh token:', error);
                return undefined;
            });
    }

    setToken(tokenData: AuthResponse) {
        if (tokenData && tokenData !== null) {
            this.accessToken = tokenData.access_token;
            var baseUrl = tokenData.api_endpoint.replace("/api/", '');
            sessionStorage.setItem(environment.ACCESS_TOKEN_KEY, tokenData.access_token);
            sessionStorage.setItem(environment.REFRESH_TOKEN_KEY, tokenData.refresh_token);
            sessionStorage.setItem(environment.API_ENDPOINT, baseUrl);
            sessionStorage.setItem(environment.ORG_KEY, tokenData.orgkey);
            this.getUserDetailsFromToken(this.accessToken);
            //this.validateToken(data.accessToken);
        }
    }

    //validateToken(token: string | null) {
    //    token = this.accessToken = token || sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
    //    // head of token
    //    let jsonTokenPayload = token ? JSON.parse(atob(token.split('.')[0])) : "";

    //    if (!token) {
    //        console.log('access token not found')
    //    }
    //    else {
    //        var payloadObject = this.parseJWT(token);
    //        if (new Date(payloadObject.exp * 1000) < new Date()) {
    //            console.log("invalid token:token expired.")
    //            sessionStorage.clear();
    //            this.router.navigate(['/authorize'])
    //        } else if (payloadObject.aud !== jsonTokenPayload.aud) {
    //            console.error("invalid token : audience mismatch")
    //            sessionStorage.clear();
    //            this.router.navigate(['/authorize'])
    //        } else if (payloadObject.iss !== jsonTokenPayload.iss) {
    //            console.log("invalid token:issuer mismatch.")
    //            sessionStorage.clear();
    //            this.router.navigate(['/authorize'])
    //        }
    //    }
    //}

    private parseJWT(token: string) {
        try {
            let base64url = token.split('.')[1];
            let base64 = base64url.replace('+', '-').replace('_', '/');
            return JSON.parse(atob(base64));
        } catch {
            return null
        }
    }

    getUserDetailsFromToken(accessToken: string) {
        if (accessToken) {
            var baseUrl = sessionStorage.getItem(environment.API_ENDPOINT);
            let userDetails = this.dataService.get(`api/Auth/user?accessToken=${accessToken}&baseUrl=${baseUrl}`).toPromise().then(
                data => {
                    sessionStorage.setItem('user-details', JSON.stringify(data));

                    const userDetailsString = sessionStorage.getItem('user-details');

                    if (userDetailsString) {
                        this.userDetails = JSON.parse(userDetailsString) as UserDetails;
                        const firstInitial = this.userDetails.firstName?.charAt(0).toUpperCase() || '';
                        const lastInitial = this.userDetails.lastName?.charAt(0).toUpperCase() || '';
                        this.userDetails.avatar = `${firstInitial}${lastInitial}`;
                    }
                }
            );
        }
    }

    loadUserDetailsFromSession(): void {
        const userDetailsString = sessionStorage.getItem('user-details');

        if (userDetailsString) {
            this.userDetails = JSON.parse(userDetailsString) as UserDetails;

            if (!this.userDetails.avatar) {
                const firstInitial = this.userDetails.firstName?.charAt(0).toUpperCase() || '';
                const lastInitial = this.userDetails.lastName?.charAt(0).toUpperCase() || '';
                this.userDetails.avatar = `${firstInitial}${lastInitial}`;
            }
        }
    }
}
